import React from 'react';
import PropTypes from 'prop-types';
import { pureRender } from 'epic-alt-utils/index';
import NavActions from '../../actions';
import { getDataAttribute } from 'epic-common/src/browser';
import { UserIcon } from '../';

@pureRender
export default class SignIn extends React.Component {
    static propTypes = {
        isActive: PropTypes.bool,
        signInLinks: PropTypes.array,
        hideCallToAction: PropTypes.bool
    };
    static contextTypes = {
        messages: PropTypes.object,
        isMobile: PropTypes.bool,
        globalLinkOnClick: PropTypes.func
    };

    onClick = (e) => {
        const index = getDataAttribute(e.currentTarget, 'index');
        const signInLink = this.props.signInLinks[index];
        const href = signInLink.href;
        let globalReturnValue = null;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            globalReturnValue = this.context.globalLinkOnClick(e, href);
        }

        if (globalReturnValue !== false) {
            if (signInLink && signInLink.onClick && typeof signInLink.onClick === 'function') {
                signInLink.onClick(e);
            }
        }

        NavActions.closeMobileTablet.defer();
    };

    close = () => {
        NavActions.mobileUserActive(false);
        NavActions.mobileNavActiveLinks(true);
    };

    render() {
        if (!this.props.signInLinks) {
            console.warn('[EGH] signInLinks array is empty, hiding signIn...');
            return <div />;
        }

        const signInLinks = this.props.signInLinks.asMutable ? this.props.signInLinks.asMutable() : this.props.signInLinks || [];
        const dropdown = signInLinks.length > 1;
        const messages = this.context.messages || {};
        const isMobile = this.context.isMobile || false;

        const ulClasses = `bg-color ${this.context.isMobile ? 'mobile-list' : ''} ${this.props.hideCallToAction ? 'ul-right' : 'ul-left'}`;

        return (
            <div
                id="user"
                role="button"
                tabIndex="0"
                onClick={this.showSignIn}
                className={`sign-in accent-bg-color-before bg-color ${this.props.isActive && isMobile ? 'active' : ''} ${dropdown ? 'dropdown' : ''}`}>

                {!isMobile ?
                    <UserIcon
                        isLoggedIn={false}
                        mobileUserActive={this.props.isActive}
                        signInLinks={this.props.signInLinks} /> : ''}

                <ul className={ulClasses}>
                    {isMobile ?
                        <li
                            role="menuitem"
                            className="mobile-heading"
                            onClick={this.close}>
                            <a><span>{messages.sign_in}</span></a>
                        </li> : ''}
                    {
                        signInLinks.map((signInLink, i) => {
                            if (signInLink) {
                                return (
                                    <li key={`sign-in-${signInLink.title}`} className={`${this.context.isMobile ? 'mobile-list-item' : ''}`}>
                                        <a
                                            href={signInLink.href || '#'}
                                            data-index={i}
                                            onClick={this.onClick}
                                            title={dropdown ? signInLink.title : messages.sign_in}
                                            className="text-color-hover text-color-nonactive">
                                            <i className="eg-header-icon-user" />
                                            <span className="sign-text item-label">{dropdown ? signInLink.title : ''}</span>
                                        </a>
                                    </li>
                                );
                            }
                            return undefined;
                        })
                    }
                </ul>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/scripts/components/signIn/SignIn.js